function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var t = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var L = Object.prototype.hasOwnProperty,
    p = Object.prototype.propertyIsEnumerable;

var C = function C(o, l, e) {
  return l in o ? t(o, l, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : o[l] = e;
},
    d = function d(o, l) {
  for (var e in l || (l = {})) {
    L.call(l, e) && C(o, e, l[e]);
  }

  if (n) {
    var _iterator = _createForOfIteratorHelper(n(l)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        p.call(l, e) && C(o, e, l[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return o;
};

import * as i from "react";

function f(o) {
  return i.createElement("svg", d({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3869 7.3291C19.0062 7.7201 18.3907 7.7201 18.0099 7.3291C17.6291 6.9381 17.6291 6.3061 18.0099 5.9141C18.3907 5.5241 19.0062 5.5241 19.3869 5.9141C19.7677 6.3061 19.7677 6.9381 19.3869 7.3291ZM20.764 4.5001C19.8125 3.5241 18.2728 3.5241 17.3214 4.5001L13.8778 8.0361L12.5008 6.6221C11.7402 5.8411 10.5073 5.8411 9.74667 6.6221L8.36963 8.0361L17.3214 17.2281L18.6984 15.8141C19.459 15.0341 19.459 13.7671 18.6984 12.9861L17.3214 11.5731L20.764 8.0361C21.7155 7.0601 21.7155 5.4771 20.764 4.5001Z",
    fill: "black"
  }), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30241 11.5728C4.92537 12.9858 3.23961 12.6698 2.8598 12.2788C2.47902 12.6698 2.47902 13.3028 2.8598 13.6938L9.05747 20.0578C11.123 22.1788 13.1886 20.0578 13.1886 20.0578L15.9437 17.2288L8.36895 9.45081L6.30241 11.5728Z",
    fill: "black"
  }));
}

export { f as ReactComponent };